<template>
    <button class="button is-small is-primary logout" @click="logout">Log Me Out&nbsp;<i class="fa fa-sign-out"></i></button>
</template>

<script>
    export default {
        methods: {
            async logout() {
                await this.$root.$data.setters.logOut(this.$root.$data.state)
                localStorage.removeItem("user")
				this.$notify({
					group: 'global',
					type: 'success',
					title: 'Logout Successful',
					text: 'You have been logged out.',
				})
                this.$router.push("/login")
                this.$emit("toggle-menu")
            }
        }
    }
</script>